import { render } from "./VendorReport.vue?vue&type=template&id=faeff166&scoped=true"
import script from "./VendorReport.vue?vue&type=script&lang=js"
export * from "./VendorReport.vue?vue&type=script&lang=js"

import "./VendorReport.vue?vue&type=style&index=0&id=faeff166&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faeff166"]])

export default __exports__